import './InformationOverlay.css';
export var InformationOverlayTriggerCSS = '_by0m3w0-3-12-1';
export var InformationOverlayTriggerIconCSS = '_by0m3w4-3-12-1';
export var InformationOverlayTriggerIconHoverCSS = '_by0m3w5-3-12-1';
export var InformationOverlayTriggerIconVariantsCSS = {primary:'_by0m3w6-3-12-1',success:'_by0m3w7-3-12-1',warning:'_by0m3w8-3-12-1',critical:'_by0m3w9-3-12-1',neutral:'_by0m3wa-3-12-1',onAccent:'_by0m3wb-3-12-1'};
export var InformationOverlayTriggerTextCSS = '_by0m3w1-3-12-1';